// Students Progress — step 1: course picker ("/app/students-progress").
// Teacher-only; route-guards itself the same way TeacherProfileEdit.jsx
// does rather than relying on App.js to hide the route. Picking a course
// drills into StudentsProgressCourse.jsx for the ranked student list.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Users, TrendingUp } from "lucide-react";

export default function StudentsProgress() {
  const { user } = useAuth();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    if (user?.role === "teacher" || user?.role === "admin") {
      api.get("/teacher/courses").then((r) => setCourses(r.data));
    }
  }, [user]);

  if (user?.role !== "teacher" && user?.role !== "admin") {
    return <p className="text-sm text-red-600" data-testid="students-progress-forbidden">This page is for teachers only.</p>;
  }

  return (
    <div className="space-y-6" data-testid="students-progress-page">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-blue-700">Students Progress</p>
        <h1 className="font-heading text-3xl font-black tracking-tight mt-1">Pick a course</h1>
        <p className="text-sm text-zinc-500 mt-2">See a ranked view of every enrolled student's Test and Daily Performance averages, then drill into any student's full history.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {courses.map((c) => (
          <Link
            key={c.id}
            to={`/app/students-progress/${c.id}`}
            data-testid={`students-progress-course-${c.id}`}
            className="border border-zinc-200 p-5 hover:border-zinc-300 hover:shadow-sm transition-all block"
          >
            <span className="text-xs uppercase tracking-[0.15em] font-semibold text-blue-700">{c.subject}</span>
            <h3 className="font-heading font-bold mt-1.5">{c.title}</h3>
            <div className="flex items-center justify-between mt-4">
              <span className="text-xs text-zinc-500 inline-flex items-center gap-1"><Users className="w-3.5 h-3.5" />{c.enrolled_count} enrolled</span>
              <span className="text-sm font-semibold text-blue-700 inline-flex items-center gap-1">View progress <TrendingUp className="w-3.5 h-3.5" /></span>
            </div>
          </Link>
        ))}
      </div>
      {courses.length === 0 && <p className="text-sm text-zinc-500 py-8" data-testid="students-progress-empty">You haven't created any courses yet.</p>}
    </div>
  );
}
